import React from 'react'
import { Link } from 'react-scroll'
import { HiArrowNarrowRight } from 'react-icons/hi'

function Home() {

    return (
        <div name='home' className='bg-[#0a192f] text- w-full h-screen'>
            {/* Container */}
            <div className="max-w-[850px] h-full mx-auto px-8 flex flex-col justify-center">
                <p className='text-pink-600 text-3xl my-2'>Hi! I am </p>
                <h1 className='text-4xl sm:text-5xl font-bold text-white animate__animated animate__zoomInDown animate__delay-0.5s'>Alistair Saldanha</h1>
                <h2 className='text-4xl sm:text-5xl font-bold text-[#abb0c0c5] animate__animated animate__zoomInDown animate__delay-1s'>I'm a <span className='text-blue-600 underline'>Full Stack</span> Web Developer</h2>
                <p className='text-white py-4 max-w-[750px]'> A Fourth-year undergraduate student at Dwarkadas J. Sanghvi College of Engineering pursuing a B.Tech. in Computer Science and Engineering (Data Science).
                    <br></br>Unlock the power of captivating user experiences with my awesome development expertise. </p>
                <div>
                    <button className='text-white border-2 px-6 py-3 my-2 flex justify-between items-center hover:bg-pink-600 hover:border-pink-600 duration-300 transition-ease-in'><Link to="projects" smooth={true} duration={1000}>View Work</Link><HiArrowNarrowRight className='ml-3' /> </button>
                </div>
            </div>
        </div>
    )
}

export default Home